import React from 'react';
import { Controller } from 'react-hook-form';
import { Field } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { colors } from 'theme';

import { SelectPropTypes } from './data';

const CurrencyInput: React.FC<SelectPropTypes> = ({
  invalid,
  data,
  defaultValue,
  name,
  control,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, name, ref } }) => (
        <Field.Root invalid={invalid}>
          <Select
            ref={ref}
            name={name}
            defaultValue={defaultValue}
            options={data}
            variant="subtle"
            onChange={onChange}
            value={value}
            chakraStyles={{
              container: () => ({
                background: 'transparent',
                color: colors.body,
                fontSize: '1.625rem',
                fontFamily: 'Inter',
                fontWeight: 'semibold',
                textTransform: 'uppercase',
              }),

              placeholder: () => ({
                color: colors.body2,
                fontSize: '26px',
              }),
              control: () => ({
                fontSize: '26px',
                display: 'flex',
                alignItems: 'center',
                color: colors.body,
              }),
              singleValue: (provided) => ({
                ...provided,
                color: colors.body,
              }),
              input: (provided) => ({
                ...provided,
                color: colors.body,
              }),
              indicatorsContainer: () => ({}),
              valueContainer: () => ({
                display: 'flex',
                alignItems: 'center',
              }),
              menu: (provided) => ({
                ...provided,
                marginBlock: 0,
                backgroundColor: colors.dark,
                zIndex: 20,
              }),
              menuList: () => ({
                borderRadius: '8px',
                backgroundColor: colors.dark,
                border: `1px solid ${colors.body2}`,
                marginBlock: 0,
                padding: '4px 0',
              }),
              downChevron: (provided, { selectProps }) => ({
                ...provided,
                color: colors.body,
                transition: '300ms',
                transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
                cursor: 'pointer',
                marginLeft: '-10px',
                fontSize: '34px',
                lineHeight: '34px',
              }),
              inputContainer: (provided) => ({
                ...provided,
                maxW: 'max-content',
              }),
              option: (provided, { isSelected, isFocused }) => ({
                ...provided,
                cursor: 'pointer',
                color: colors.body,
                backgroundColor: isFocused
                  ? '#2a2c34'
                  : isSelected
                    ? 'rgba(62, 207, 142, 0.14)'
                    : colors.dark,
                ':first-of-type': { borderRadius: '8px 8px 0 0' },
                ':last-of-type': { borderRadius: '0 0 8px 8px' },
                ':active': {
                  backgroundColor: '#2a2c34',
                },
              }),
            }}
          />
        </Field.Root>
      )}
    />
  );
};

CurrencyInput.displayName = 'CurrencyInput';

export default CurrencyInput;
